var map = {
	"./config.json": "teVF",
	"./en-FR/404.json": "18Ck",
	"./en-FR/blog.json": "V/c/",
	"./en-FR/translation.json": "Dru1",
	"./en-FR/translation_old.json": "26XI",
	"./en/404.json": "+8IV",
	"./en/blog.json": "J1Sy",
	"./en/translation.json": "Pz+C",
	"./en/translation_old.json": "uTUT",
	"./fr/404.json": "qfoD",
	"./fr/blog.json": "5O85",
	"./fr/translation.json": "R6/m",
	"./fr/translation_old.json": "YPCC"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Lhal";